import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";
// this is a  circular import but AppThunk is a type, and types can be handled by the TS compiler or at least I hope, so :)
import { AppThunk } from "../index";

export type ModalType =
  | "stake"
  | "autoplay"
  | "info"
  | "help"
  | "pays"
  | "error"
  | "message"
  | "freeRounds"
  | "freeRoundsEnd"
  | "history"
  | "realityCheck"
  | "buyBonus"
  | "selectBuyBonus"
  | "previousWin";

interface ModalsState {
  active: ModalType | null;
  closing: boolean;
  backdrop: boolean;
}

const modals = createSlice({
  name: "modals",
  initialState: initialState.modals as ModalsState,
  reducers: {
    openModal(state, action: PayloadAction<ModalType>) {
      // if an error is opend no other modal is visulized
      if (state.active === "error" && action.payload !== "error") {
        return state;
      }
      return { ...state, active: action.payload, backdrop: true, closing: false };
    },

    closeModal(state, action: PayloadAction<boolean | undefined>) {
      return { ...state, active: null, closing: false, backdrop: !!action?.payload };
    },

    setAsClosing(state) {
      return { ...state, closing: true };
    },
  },
});

export const { openModal, closeModal } = modals.actions;

export const delayedCloseModal =
  (type: ModalType, delay: number): AppThunk =>
  (dispatch, getState) => {
    dispatch(modals.actions.setAsClosing());

    setTimeout(() => {
      const state = getState();
      if (state.modals.active === type && state.modals.closing) {
        dispatch(closeModal());
      }
    }, delay);
  };

export const delayedOpenModal =
  (type: ModalType, delay: number): AppThunk =>
  (dispatch) => {
    setTimeout(() => {
      dispatch(openModal(type));
    }, delay);
  };
export default modals;
